'use client';
import Typography from '@components/ui/Typography';
import { DocumentType } from '../../types/documentType';
import onDocumentClick from '@utils/onDocumentClick';
import { useState } from 'react';
import Loading from '@components/loading';

const disclosures = [
  {
    label: 'Coign Privacy Policy',
    type: DocumentType.CoignPrivacyPolicy,
  },
  {
    label: 'Coign Reward Program Terms and Conditions',
    type: DocumentType.RewardsTermsAndConditions,
  },
  {
    label: 'Coign Application Disclosures',
    type: DocumentType.ApplicationDisclosures,
  },
  {
    label: 'Coign Privacy Notice',
    type: DocumentType.CoignFinancialPrivacyNotice,
  },
  {
    label: 'MRV Banks Privacy Notice',
    type: DocumentType.PrivacyNoticeMrv,
  },
  {
    label: 'MRV Banks Electronic Communications Consent',
    type: DocumentType.ESignActConsent,
  },
  {
    label: 'Coign Charitable Donation Terms and Conditions',
    type: DocumentType.DonationTermsAndConditions,
  },
  {
    label: 'TCPA Disclosure',
    type: DocumentType.ReceiveCallsAndSmsConsent,
  },
  {
    label: 'Coign Card Benefits Guide',
    type: DocumentType.CoignBenefitsGuide,
  },
];

export default function Disclosures() {
  const [isLoading, setIsLoading] = useState(false);

  const handleDocumentClick = async (type: DocumentType) => {
    setIsLoading(true);
    try {
      await onDocumentClick(type);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <div className="container mb-96">
      <div>
        <Typography intent="displayMedium">Disclosures</Typography>
      </div>

      <div className="mt-4 flex w-fit flex-col gap-2">
        {disclosures.map(({ label, type }, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleDocumentClick(type)}
            className="text-left"
          >
            <Typography
              intent="headlineSmall"
              className="text-primary underline"
            >
              {label}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
}
